import React, { useEffect, Component, useState } from 'react';
import { NavLink, Link } from "react-router-dom";
import { Table, Button, Modal } from 'react-bootstrap';
import StarRatings from 'react-star-ratings';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import 'jquery/dist/jquery.min.js';
import 'jquery.easing/jquery.easing';
import "./dashboard.css"
import { Sidebar } from '../sidebar/Sidebar';
import Navbar from '../navbar/navbar';
import reveiw from "../images/rating.png";
import business from "../images/stats.png";
import feedback from "../images/feedback.png";
import individual from "../images/famous.png";
import kebab from "../images/kebab.svg";
import profile from "../images/profile.jpg";
import AdminAddBusiness from '../AdminAddBusiness/AdminAddBusiness';
import UpdateBusinessForm from '../UpdateBusinessForm/UpdateBusinessForm';
import { businessData } from "../demoData/demoData.js";
import { deleteBusiness, getBusiness } from '../../../Services/business.service';
import ConfirmationModal from '../../shared/confirmationModal/confirmationModal'
import { getReviewsCount,getReviews } from '../../../Services/reviews.service';
import { getUsersCount } from '../../../Services/users.service';
import { getCategories } from '../../../Services/category.service'
import _ from 'lodash';

export const AdminDashboard = () => {
  const [show, setShow] = useState(false);
  const [showEditForm, setShowEditForm] = useState(false);
  const [editItem, setEditItem] = useState(null)
  const [idOfEditObject, SetIdOfEditObject] = useState('');
  const [isConfirm, setIsConfirm] = useState(false)
  const [data, setData] = useState([]);
  const [handleRander, setHandleRender] = useState(true);
  const [reviewsCount, setReviewsCount] = useState(0)
  const [usersCount, setUsersCount] = useState(0)
  const [filteredList, setFilteredList] = useState([])
  const [searchValue, setSearchValue] = useState('')

  const handleClose = () => {
    getAllBusiness()
    setShow(false);
  }
  const handleShow = () => setShow(true);

  const handleCloseEdit = () => {
    getAllBusiness()
    setShowEditForm(false);
  }

  const handleShowEdit = (id, item) => {
    setEditItem(item)
    SetIdOfEditObject(id);
    setShowEditForm(true);
  }
  const redColor = {
    color: 'red'
  }
  const greenColor = {
    color: '#28CB89'
  }

  useEffect(() => {
    getAllBusiness()
    getUsersCount().then(r => {
      setUsersCount(r)
    })
    // setData(businessData)
  }, [])

  let getAllBusiness = async () => {
    let business = await getBusiness();
    let categories = await getCategories();
    let businesReviews = await 
    getReviewsCount().then(r => {
      console.log("reviews", r)
      let reviewsList = []
      reviewsList = r;
      _.forEach(business, (b) => {
        b.totalReviews = 0;
        for (let i = 0; i <= reviewsList.length - 1; i++) {
          if (b.businessId == reviewsList[i].businessId) {
            b.totalReviews++;
          }
        }

        for (let j = 0; j <= categories.length - 1; j++) {
          if (b.category == categories[j].categoryId) {
            b.categoryName = categories[j].name;
          }
        }

      })
      // Thre is no reason of the line below
      setReviewsCount(reviewsList.length)
      // Danish fixing
     // setData(business)
      console.log('get business', business)
      console.log('Cont of the review reguarding to business are : ',reviewsCount);
    })
    getReviews().then((ress) => {
      getBusiness().then((res) => {
        console.log("review responses are ", ress);
        console.log("business responses are ", res);
        for (let i = 0; i < res.length; i++) {
          for (let j = 0; j < ress.length; j++) {
            if (res[i].businessId === ress[j].itemId) {
              business[i].totalReviews=business[i].totalReviews+1;
              console.log(res[i].name);
              //let test ={name:res[i].name,review:ress[j].discripton,status:false,rating:ress[j].myRating};
              //filterReviews.push(test);
            }
          }
          console.log(business[i].totalReviews);
        }
        console.log(business);
        setData(business);

        //console.log("Fliter reviews are : ", filterReviews);
       // setuserReviews(filterReviews);
      });
    });



  }

  const removeHandle = (id, index) => {
    console.log(id, index);
    if (!!id) {
      deleteBusiness(id).then(resp => {
        console.log('delete resp', resp);
        const removeArr = [...data].filter(todo => todo.businessId !== id) //all id matches except which we want to remove
        data.splice(index, 1)
        setData(removeArr) //remove from state
        setIsConfirm(false)
        localStorage.removeItem('bId')
        localStorage.removeItem('bId')
      })
    }

  }


  // const removeHandle = (id, index) => {
  //   const removeArr = [...businessData].filter(todo => todo.id !== id);//all id matches except which we want to remove
  //   businessData.splice(index, 1);
  //   setData(removeArr); //remove from state  
  //   console.log(removeArr);

  // }
  const updateData = (val) => {
    console.log(idOfEditObject);
    console.log(val); //updated value
    for (var i = 0; i < businessData.length; i++) {
      if (businessData[i].id === idOfEditObject) {
        if (val.BusinessName != "") {
          businessData[i].BName = val.BusinessName;
        }
        if (val.category != "") { businessData[i].category = val.category; }
        if (val.fullAddress != "") { businessData[i].address = val.fullAddress; }
        if (val.description != "") { businessData[i].description = val.description; }
        if (val.status != "") { businessData[i].status = val.status; }
        // return;
      }
    }
    setTimeout(function () {
      handleCloseEdit()
    }, 300)
    // setData(businessData);

  }

  let toggleModal = (businessId, index) => {
    localStorage.bId = businessId
    localStorage.indexId = index
    setIsConfirm(true)
  }

  // const  removeHandle = (id,index) => {
  //   businessData.splice(index,1); // remove from original data
  //   setData(businessData); //remove from state  
  //   console.log(businessData);
  //   if(handleRander == true){
  //     setHandleRender(false)
  //   }
  //   else{
  //     setHandleRender(true)
  //   }
  // }

  let handleSearchValue = (value) => {
    console.log(value);
    let search = value;
    search = search.trim();
    search = search.toLowerCase();

    if (!!search) {
      setSearchValue(search)
      let localList = [];
      _.forEach(data, (value) => {

        if (_.includes((value.name).toLowerCase(), search) || _.includes((value.address).toLowerCase(), search) || _.includes((value.category).toLowerCase(), search)) {
          localList.push(value);
        }

      });
      setFilteredList(localList)
    }
    else {
      setSearchValue(search)
      let localList = [];
      setFilteredList(localList)
    }
  }

  return (
    <>

      {/* Page Wrapper */}
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* End of Sidebar */}
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            <Navbar setValue={handleSearchValue} />

            {/* Begin Page Content */}
            <div className="container-fluid">
              <div className="row mb-4">
                <div className="col text-end">
                  <a className="btn  themeBtn" onClick={handleShow}>Add Business</a>
                </div>
              </div>

              {/* Content Row */}
              <div className="row">
                {/* Earnings (Monthly) Card Example */}
                <AnalyticsBox icon={business} title="Total Business" amount={data.length} />
                <AnalyticsBox icon={reveiw} title="Total Reviews" amount={reviewsCount} />
                <AnalyticsBox icon={feedback} title="Feedback" amount="0" />
                <AnalyticsBox icon={individual} title="Users" amount={usersCount} />
              </div>

              {/* Content Row */}
              <div className="row">
                <div className="col">
                  <h2 className="theme-color">Recent Business</h2>
                </div>
              </div>
              <div className="row">

                <div className="col-12">
                  <Table responsive striped bordered hover className="bg-white dashboardTable">
                    <thead>
                      <tr>
                        <th >Listing Name</th>
                        <th >Category</th>
                        <th >Address</th>
                        <th >Description</th>
                        <th >Total Reviews</th>
                        <th >Status</th>
                        <th></th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {!!searchValue ?
                        filteredList.length > 0 ?
                          filteredList.map((item, index) =>
                            <tr key={index}>
                              <td>
                                <div className="d-flex ai-center">
                                  <img className="driver-img rounded-circle" src={item.logoURL} alt='' />
                                  <span className="mr-2 fs-14 small profile-name ml-2 w-mc">{item.name}</span>
                                </div>
                              </td>
                              <td>{item.categoryName}</td>
                              <td><p className="mb-0 w-mc fs-14">{item.address}</p></td>
                              <td className="mw220 fs-14">{item.description}</td>
                              <td>
                                {item.totalReviews}
                                {/* <div className="w-mc">
                                  <StarRatings
                                    rating={item.rating}
                                    starDimension="18px"
                                    starSpacing="1px"
                                    numberOfStars={5}
                                    starRatedColor="orange"
                                  />
                                </div> */}
                              </td>
                              <td className="fs-14">{item.status ? 'Active' : 'Deactive'}</td>
                              <td><button className="btn btn-success w-100 fs-14" onClick={() => handleShowEdit(item.businessId, item)}>Edit</button></td>
                              <td><button className="btn btn-success w-100 fs-14">
                                <NavLink to={{
                                  pathname: "/admin/business-details",
                                  businessData: item
                                }} className="color-white">Detail</NavLink>
                              </button></td>
                              <td><button className="btn btn-danger w-100 fs-14" onClick={() => toggleModal(item.businessId, index)}>Delete</button></td>
                            </tr>
                          )
                          :
                          <tr>
                            <td className="fs-14 text-center" colSpan={9}>Nothing found...</td>
                          </tr>
                        :
                        data.map((item, index) =>
                          <tr key={index}>
                            <td>
                              <div className="d-flex ai-center">
                                <img className="driver-img rounded-circle" src={item.logoURL} />
                                <span className="mr-2 fs-14 small profile-name ml-2 w-mc">{item.name}</span>
                              </div>
                            </td>
                            <td>{item.categoryName}</td>
                            <td><p className="mb-0 w-mc fs-14">{item.address}</p></td>
                            <td className="mw220 fs-14">{item.description}</td>
                            <td>
                              {item.totalReviews}
                              {/* <div className="w-mc">
                                <StarRatings
                                  rating={item.rating}
                                  starDimension="18px"
                                  starSpacing="1px"
                                  numberOfStars={5}
                                  starRatedColor="orange"
                                />
                              </div> */}
                            </td>
                            <td className="fs-14">{item.status ? 'Active' : 'Deactive'}</td>
                            <td><button className="btn btn-success w-100 fs-14" onClick={() => handleShowEdit(item.businessId, item)}>Edit</button></td>
                            <td><button className="btn btn-success w-100 fs-14">
                                <NavLink to={{
                                  pathname: "/admin/business-details",
                                  businessData: item
                                }} className="color-white">Detail</NavLink>
                              </button></td>
                            <td><button className="btn btn-danger w-100 fs-14" onClick={() => toggleModal(item.businessId, index)}>Delete</button></td>
                          </tr>
                        )
                      }

                    </tbody>
                  </Table>
                </div>
              </div>

            </div>
            {/* /.container-fluid */}

          </div>
          {/* End of Main Content */}
        </div>
        {/* End of Content Wrapper */}
      </div>
      {/* End of Page Wrapper */}

      {/* Scroll to Top Button*/}
      <a className="scroll-to-top rounded" href="#">
        <i className="fas fa-angle-up" />
      </a>

      {/* add business modal */}
      <Modal show={show} onHide={handleClose} className="addBusinessModal">
        <Modal.Header >
          <div className=" headerColor  text-center col-12">
            <h3 className="bold-font h4 mb-0 themeColor2 text-center"><i className="fa fa-envelope" /> Add Business</h3>
          </div>
          <span className="close" onClick={handleClose}><i class="fa fa-times" aria-hidden="true"></i></span>
        </Modal.Header>
        <AdminAddBusiness setHandleClose={handleClose} />

      </Modal>

      {/* Edit business modal */}
      <Modal show={showEditForm} onHide={handleCloseEdit} className="addBusinessModal">
        <Modal.Header >
          <div className=" headerColor  text-center col-12">
            <h3 className="bold-font h4 mb-0 themeColor2 text-center"><i className="fa fa-envelope" /> Edit Business</h3>
          </div>
          <span className="close" onClick={handleCloseEdit}><i class="fa fa-times" aria-hidden="true"></i></span>
        </Modal.Header>
        <AdminAddBusiness setHandleClose={handleCloseEdit} businessData={editItem} />
        {/* <UpdateBusinessForm  val={updateData} /> */}

      </Modal>

      {isConfirm ?
        <ConfirmationModal isShowModal={isConfirm}
          callback={(type) => {
            console.log('callback type', type);
            if (type == 'delete') {
              removeHandle(localStorage.bId, localStorage.indexId)
            }
            else if (type == 'hide') {
              setIsConfirm(false)
            }
          }}
        />
        :
        null
      }
    </>
  )
}

function AnalyticsBox(props) {
  return (
    <div className="col-xl-3 col-md-6 mb-4">
      <div className="card h-100 py-2 border-transparent br-10">
        <div className="card-body">
          <div className="row no-gutters align-items-center">
            <div className="col">
              <img className="analytic-box-img" src={props.icon} alt="" />
            </div>
            <div className="col-auto mr-2">
              <div className="text-xs font-weight-bold  mb-1">
                <span className="analytics-box-title">{props.title}</span> <span className="analytic-percentage ml-2" style={props.color}>{props.percent}</span>
              </div>
              <div className="h4 mb-0 font-weight-bold text-gray-800">{props.amount}<span className="mile">{props.mile}</span></div>
              <div>
                <span className="last-month">{props.lastMonthAmount}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )

}

